import { useAllOrderDesigns } from "@jasper/use-cases";
import { Table, Pagination } from "@jasper/shared";
import { ActionIcon, Menu } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { OrderDesignStatus } from "@jasper/client-models";
import { IconDots } from "@tabler/icons-react";

const __TAKE__ = 10;

const DesignNotificationPage = ({
  onlyUntranslatedComment,
}: {
  onlyUntranslatedComment: boolean;
}) => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const status = searchParams
    .get("status")
    ?.toUpperCase() as OrderDesignStatus | null;
  const [pageNumber, setPageNumber] = useState<number>(
    parseInt(searchParams.get("page") ?? "0", 10)
  );
  const skip = pageNumber * __TAKE__;

  const { allOrderDesigns, totalCount } = useAllOrderDesigns({
    take: __TAKE__,
    skip: skip,
    statuses: status ? [status] : undefined,
    onlyUntranslatedComment: onlyUntranslatedComment,
  });

  return (
    <>
      <Table
        columns={[
          "Order reference",
          "Status",
          "Doctor",
          "Provider",
          "Date",
          "Actions",
        ]}
        rows={allOrderDesigns?.map((orderDesign, i) => [
          orderDesign.order.orderReference,
          orderDesign.status,
          `${orderDesign.order.user.firstName} ${orderDesign.order.user.lastName}`,
          orderDesign.order.provider?.name,
          new Date(orderDesign.createdAt).toLocaleDateString(),
          <Menu key={i}>
            <Menu.Target>
              <ActionIcon variant="subtle" c="gray">
                <IconDots />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                onClick={() => navigate(`/orders/${orderDesign.order.id}`)}
              >
                View order
              </Menu.Item>
              <Menu.Item
                onClick={() =>
                  navigate(
                    `/orders/${orderDesign.order.id}/designs?activeDesignId=${orderDesign.id}`
                  )
                }
              >
                View design
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>,
        ])}
        eventClick={[]}
      />
      <Pagination
        pageNumber={pageNumber}
        pageSize={__TAKE__}
        totalCount={totalCount}
        onPageChange={nextPage => {
          navigate(`/order-designs?page=${nextPage}`);
          setPageNumber(nextPage);
        }}
      />
    </>
  );
};

export default DesignNotificationPage;
